import { action, computed, observable } from 'mobx';

import { TOASTIFY_TYPE } from 'click-controls/constant/enums';

class ToastifyStore {
  @observable openNotify: boolean = false;
  @observable message?: string;
  @observable messageType?: TOASTIFY_TYPE;

  @computed
  get openNotifyPanel(): boolean {
    return !!this.message && this.messageType !== undefined;
  }

  @action.bound
  closeNotifyPanel(): void {
    this._setMessage(undefined, undefined);
  }

  @action.bound
  setMessage(type: TOASTIFY_TYPE, message: string): void {
    if (this.openNotifyPanel) {
      setTimeout(() => this._setMessage(type, message), 1000);
      return;
    }

    this._setMessage(type, message);
  }

  @action.bound
  info(message: string) {
    this.setMessage(TOASTIFY_TYPE.Info, message);
  }

  @action.bound
  success(message: string) {
    this.setMessage(TOASTIFY_TYPE.Success, message);
  }

  @action.bound
  error(message: string) {
    this.setMessage(TOASTIFY_TYPE.Error, message);
  }

  @action.bound
  private _setMessage(type?: TOASTIFY_TYPE, message?: string): void {
    this.message = message;
    this.messageType = type;
  }
}

export default new ToastifyStore();
